<template>
  <div class="pc-user-nav-container public-content">
    <div class="page-header-item">
      <div class="bg-img img-cover"><img src="../assets/pc-images/user-nav-bg.jpg" /></div>
      <div class="user-info-item">
        <div class="header-item img-cover">
          <img v-if="userInfo.Header" :src="userInfo.Header" />
          <img v-else src="../assets/images/default-header.png" />
        </div>
        <div class="nickname">
          <span v-if="userInfo.Nickname">{{ userInfo.Nickname }}</span>
          <span v-else>{{ userInfo.Phone | phoneFormat }}</span>
        </div>
        <div class="id">ID {{ userInfo.Id }} <img class="btn" src="../assets//pc-images/copy-icon.png" @click="handleCopy(userInfo.Id)" /></div>
        <div class="flex-1"></div>
        <div class="vip-icon">
          {{ userInfo.VName }} <span class="btn" @click="handleShowVip">升级</span>
        </div>
      </div>
    </div>
    <div class="page-content-container">
      <div class="left-column">
        <router-link class="menu-item" :class="tabBarKey == 'user' ? 'active' : ''" :to="{path: '/user'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-user-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-user-active-icon.png" /></div>
          基础信息
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'order' ? 'active' : ''" :to="{path: '/order'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-order-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-order-active-icon.png" /></div>
          我的订单
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'balanceRecord' ? 'active' : ''" :to="{path: '/balanceRecord'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-szmx-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-szmx-active-icon.png" /></div>
          收支明细
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'content' ? 'active' : ''" :to="{path: '/content'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-nrgl-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-nrgl-active-icon.png" /></div>
          内容管理
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'website' ? 'active' : ''" :to="{path: '/website'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-fzgl-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-fzgl-active-icon.png" /></div>
          分站管理
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'setting' ? 'active' : ''" :to="{path: '/setting'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-zhsz-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-zhsz-active-icon.png" /></div>
          账户设置
        </router-link>
        <router-link class="menu-item" :class="tabBarKey == 'contact' ? 'active' : ''" :to="{path: '/contact'}">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-lxkf-icon.png" /></div>
          <div class="active-icon img-cover"><img src="../assets/pc-images/user-nav-lxkf-active-icon.png" /></div>
          联系客服
        </router-link>
        <div class="menu-item" @click="handleLogout">
          <div class="icon img-cover"><img src="../assets/pc-images/user-nav-logout-icon.png" /></div>
          退出登录
        </div>
      </div>
      <div class="right-column">
        <slot></slot>
      </div>
    </div>
    <pcVipUpgradeComponent v-if="dialog.vip" ref="vipUpgradedDialog" @success="onSuccess" @close="dialog.vip = false" />
  </div>
</template>

<script>
import pcVipUpgradeComponent from './PcVipUpgradeComponent'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'PcUserNavComponent',
  components: {
    pcVipUpgradeComponent
  },
  props: {
    tabBarKey: String
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  data() {
    return {
      searchKey: '',
      dialog: {
        vip: false
      }
    }
  },
  filters: {
    phoneFormat(text) {
      if (text) {
        return text.substr(0, 3) + '****' + text.substr(-4)
      }
      return ''
    }
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    onSuccess() {
      this.GetUserInfo()
    },
    handleShowVip() {
      this.dialog.vip = true
      this.$nextTick(() => {
        this.$refs.vipUpgradedDialog.open()
      })
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    handleLogout() {
      this.$dialog.confirm({
        type: 'info',
        className: 'pc-dialog',
        title: '提示',
        message: '确定要退出登录吗？',
        cancelButtonText: '取消',
        confirmButtonText: '确认',
      }).then(() => {
        this.$TOOL.data.clear()
        window.location.reload()
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped lang="less">
.page-header-item {
  margin-top: 20px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fff;
  .bg-img {
    width: 100%;
    height: 210px;
  }
  .user-info-item {
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .header-item {
      width: 100px;
      height: 100px;
      border-radius: 5px;
      overflow: hidden;
      margin-right: 25px;
      margin-top: -80px;
    }
    .nickname {
      font-size: 18px;
      font-weight: 500;
      color: #393942;
      margin-right: 20px;
    }
    .id {
      font-size: 12px;
      color: #383838;
      display: flex;
      align-items: center;
      .btn {
        margin-left: 10px;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }
    .vip-icon {
      display: flex;
      align-items: center;
      height: 20px;
      padding: 0 12px;
      background-color: rgba(166, 166, 166, .1);
      border-radius: 10px;
      color: #a6a6a6;
      font-size: 10px;
      .btn {
        margin-left: 5px;
        color: #2563eb;
        cursor: pointer;
      }
    }
  }
}
.page-content-container {
  margin-top: 20px;
  display: flex;
  padding-bottom: 20px;
  .left-column {
    width: 184px;
    padding: 40px 0;
    margin-right: 20px;
    background-color: #fff;
    border-radius: 5px;
    .menu-item {
      padding-left: 50px;
      margin-bottom: 33px;
      height: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #64748b;
      font-size: 12px;
      &.active {
        color: #5783fc;
        .active-icon {
          display: block;
        }
        .icon {
          display: none;
        }
      }
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 20px;
      }
      .active-icon {
        display: none;
        width: 16px;
        height: 16px;
        margin-right: 20px;
      }
    }
  }
  .right-column {
    flex: 1;
  }
}
</style>